import create from "./create.ts";
import draftAll from "./draftAll.ts";
import draftOne from "./draftOne.ts";
import * as dunkContest from "./dunkContest.ts";
import getOrCreate from "./getOrCreate.ts";
import nextGameIsAllStar from "./nextGameIsAllStar.ts";
import * as threeContest from "./threeContest.ts";

export default {
	create,
	draftAll,
	draftOne,
	dunkContest,
	getOrCreate,
	nextGameIsAllStar,
	threeContest,
};
